import React from 'react';

import { extLnkCollectionNomination } from '../../../../config/track-config';
import { useCurrentArticle } from '../../hooks/shipment.hooks';
import AccordionWrapper from '../AccordionWrapper/AccordionWrapper';
import LinkRow from '../RowCard/LinkRow/LinkRow';
import RowCard from '../RowCard/RowCard';
import { ROW_CARD_ICONS } from '../RowCard/RowContent/RowContent';
import { COLLECTION_OPTIONS_TEST_ID, DELEGATION_ROW_TEST_ID } from './CollectionOptions.test-ids';

const CollectionOptions: React.FC = () => {
  const { articleId = '', collectionInstruction } = useCurrentArticle() || {};
  const delegationAllowed = collectionInstruction?.delegate?.allowed || false;
  const heading = 'Collection options';

  if (!delegationAllowed) return null;
  const delegationLink = extLnkCollectionNomination(articleId ?? '');

  const collectionOptions = (
    <LinkRow
      icon={ROW_CARD_ICONS.happy}
      text='Let someone else collect it'
      href={delegationLink}
      data-testid={DELEGATION_ROW_TEST_ID}
    />
  );

  return (
    <AccordionWrapper heading={heading} id='accordionCollectionOptions'>
      <RowCard groupHeading={heading} data-testid={COLLECTION_OPTIONS_TEST_ID}>
        {collectionOptions}
      </RowCard>
    </AccordionWrapper>
  );
};

export default CollectionOptions;
